module.exports = __webpack_public_path__ + "bf9009594b886bac07f9e172ead2f2bf.pdf";